import React from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTheme } from '@webtrader/core/services/theme/v2';

import Ionicons from '@/components/Icons/Ionic';
import TouchableOpacity from '@/components/Touch/Opacity';

interface ICheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  onCheck?: (checked: boolean) => void;
  testID?: EDataTestId;
}

const CHECK_SIZE = dynamicSize.convertSize(18);

const Checkbox: FCC<ICheckboxProps> = (props) => {
  const { checked = false, disabled = false, children, onCheck, testID } = props;

  const onPressSelector = () => {
    onCheck?.(!checked);
  };

  const { theme } = useTheme();

  return (
    <CheckboxSelector activeOpacity={1} onPress={onPressSelector} disabled={disabled}>
      <CheckboxSelectorCheck>
        <CheckboxSelectorCheckIcon checked={checked} testID={testID}>
          {checked && (
            <Ionicons
              name="checkmark-sharp"
              size={dynamicSize.convertSize(14)}
              color={checked ? theme.colors.primary : theme.colors.text[3]}
            />
          )}
        </CheckboxSelectorCheckIcon>
      </CheckboxSelectorCheck>
      <CheckboxSelectorDescription>{children}</CheckboxSelectorDescription>
    </CheckboxSelector>
  );
};

export default Checkbox;

const CheckboxSelector = styled(TouchableOpacity)`
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
`;

const CheckboxSelectorCheck = styled.View`
  padding-end: ${dynamicSize.convertSize(12)}px;
`;

const CheckboxSelectorCheckIcon = styled.View<{ checked: boolean }>`
  width: ${CHECK_SIZE}px;
  height: ${CHECK_SIZE}px;

  align-items: center;
  justify-content: center;

  border-radius: 3px;
  border-width: 1px;
  border-color: ${({ theme, checked }) => (checked ? theme.colors.primary : theme.colors.text[3])};
`;

const CheckboxSelectorDescription = styled.View`
  flex-wrap: wrap;
  flex-shrink: 1;
`;
